import { render, staticRenderFns } from "./SystemDirectory.vue?vue&type=template&id=952fa934&"
import script from "./SystemDirectory.vue?vue&type=script&lang=js&"
export * from "./SystemDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports